module.exports = __webpack_public_path__ + "img/try.8a583597.svg";